import 'ol/ol.css';
import {LineString} from 'ol/geom';
import {
  Pointer as PointerInteraction,DragBox, Select,DragPan,DragZoom
} from 'ol/interaction';
import Drag from './Drag';
import LineDraw from './LineDraw';
import store from '@/store';

export default class MouserInteraction extends PointerInteraction {
  constructor() {
    super({
      handleDownEvent: handleDownEvent,
    });

    this.dragBoxInteraction_=null // 框选交互
    this.dragPanInteration_=null // 拖动地图
    this.dragZoomInteration_=null; // 绘制放大
    this.dragInteration_=null; // 拖动要素
    this.selectInteration_=null; // 选择地图
    this.drawInteration_=null; // 绘图操作

    this.init_=init;// 初始化 
    this.mapRestore=mapRestore; // 地图复原

    this.map=null;
  }
}

/**
 * @param {import("../src/ol/MapBrowserEvent.js").default} evt Map browser event.
 * @return {boolean} `true` to start the drag sequence.
 */
function handleDownEvent(evt) {
  // 判断当前点击是否
  const map = evt.map;
  this.map=map;
  // 初始化
  this.init_();
  // 判断鼠标左右中键,当点击了右键和滚轮的时候，不进行坐标记录
  store.commit("simulation/hideContextMenu"); // 取消右键显示
  let button=evt.originalEvent.button;

  const hitTolerance=10; // 吸附半径
  const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
    return feature;
  },{
    hitTolerance:hitTolerance
  });
  let hasFeature=!!feature; // 当前鼠标位置是否存在要素
  // 鼠标右键
  if(button ==2){
    let start=null;
    if(feature){
      let geom=feature.getGeometry();
      if(geom instanceof LineString){
        start=geom.getFirstCoordinate();
      }else{
          start=geom.getCoordinates();
      }
    }
    // 触发显示
    store.commit("simulation/showContextMenu",{
      menuCoor:evt.coordinate, // 菜单坐标
      menuhasFeature:hasFeature, // 是否点击到了要素上
      menuStart:start, // 菜单上一次点击到位置
    });
    // 恢复地图状态
    this.mapRestore();
    // 停止事件响应链
    return true;
  }else{
    // 当没有点击的要素的时候，清空选中列表
    if(!hasFeature){
      // 取消选中
      store.commit("simulation/setCurFeatures",[]);
      // 取消粘贴
      // store.commit("simulation/copy",[]);
      // 取消剪切
      // store.commit("simulation/cut",[]);
    }
  }
  // 当return false的时候，后续的事件监听才能被触发
  return false;
}

/**
 * 
 */
function init(){
  if(this.dragInteration_){
    return;
  }
  let interactions=this.map.getInteractions();
  interactions.forEach(item=>{
    // 拖动
    if(item instanceof DragPan){
        this.dragPanInteration_=item;
    }
    // 选择交互
    if(item instanceof Select){
        this.selectInteration_=item;
    }
    // 放大
    if(item instanceof DragZoom){
        this.dragZoomInteration_=item;
    }
    // 放大
    if(item instanceof Drag){
        this.dragInteration_=item;
    }
    // 框选
    if(item instanceof DragBox){
      this.dragBoxInteraction_=item;
    }
    // 绘制
    if(item instanceof LineDraw){
      this.drawInteration_=item;
    }
  });
}

/**
 * 地图恢复
 */
function mapRestore(){
  // 关闭绘制
  this.drawInteration_.setActive(false);
  // 开启拖动
  this.dragInteration_.setActive(true);
  // 恢复鼠标样式
  let element=this.map.getTargetElement();
  element.style.cursor="default";
  // 恢复拖动地图
  this.dragPanInteration_.setActive(true);
  // 恢复选中
  this.selectInteration_.setActive(true);
  // 停止框选
  this.dragBoxInteraction_.setActive(false);
}
